/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, { FC, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../helpers'
import { HeaderNotificationsMenu, QuickLinks, Search, Wallet, WalletV2 } from '../../../partials'
import { useLayout } from '../../core'
import './header.scss'
import { useDispatch, useSelector } from 'react-redux'

////////////////////working///////////////////////
import {
  GetAllDataport,
  GetAllDataSysdata,
  // portalNotification,
  // SendSocketId,
  // systemNotification,
} from '../../../../app/Redux/NotificationSlice/NotificationSlice'
import { AuthenticateUser } from '../../../../app/Utils/_helpers/RoleAndPermission'
// import { GeneralDataOFLoginUser } from '../../../../app/Utils/Auth'
import { getAllUserDetails } from '../../../../app/pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import QuickMessageDrawerInner from '../../../partials/layout/drawer-messenger/Quickmessge'
// import {
//   ContactClosePopup,
//   ContactEndUpload,
//   ContactOpenPopup,
//   ContactStartUpload,
// } from '../../../../app/Components/PopupSlice/popupSlice'
// import { getUserData } from '../../../../app/modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import HeaderUserMenu from '../../../partials/layout/header-menus/HeaderUserMenu'
import { createFirstLetter } from '../../../../app/Utils/_helpers'

import { Link } from 'react-router-dom'
import { ChevronUp, ChevronDown } from 'react-bootstrap-icons'
import { useOutsideAlerter } from '../../../../app/hooks/useOutsideAlerter'
import { useInboxResponsive } from '../../../../app/pages/UserPages/inbox-v2/useInboxResponsive'
import { GLOBAL_SETTINGS_TYPE } from '../../../../app/Utils/Constant/ConstantForWebsite'

////////////////////try/////////////////
// import { QuickMsg } from 'app/Redux/AdminPanel/QuickMessageSlice'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  let { quickMessagePopup, setQuickMessagePopup } = useLayout()
  const [isQuickActionOpen, setIsQuickActionOpen] = useState(false)
  const [credit, setCredit] = useState(0)

  const userValues = useSelector(getAllUserDetails)
  const isNewNavigation = userValues?.globalSetting?.some(
    (item: string) =>
      item === GLOBAL_SETTINGS_TYPE.NEW_NAVIGATION ||
      item === GLOBAL_SETTINGS_TYPE.NEW_NAVIGATION_V3
  ) ?? false
  
  const dispatch = useDispatch()
  // const [socketID, setSocketID] = useState(io(ENDPOINT,{query:userId:"44444"}))

  const sys = useSelector((state: any) => state?.notification?.system)
  const port = useSelector((state: any) => state?.notification?.portal)

  const { config } = useLayout()
  const { isMobile } = useInboxResponsive()

  const ref = useRef(null)
  useOutsideAlerter(ref, () => {
    setIsQuickActionOpen(false)
    if (isQuickActionOpen === true) {
    }
  })

  // useEffect(() => {
  //   if (localStorage.getItem('token') !== '') {
  //     socketID.on('.', () => {
  //       if (socketID.connected) {
  //         dispatch(SendSocketId({socketId: socketID.id}))
  //       }
  //     })
  //   }
  // }, [])

  useEffect(() => {
    dispatch(GetAllDataport())
    dispatch(GetAllDataSysdata())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSetCredit = (value: number) => {
    setCredit(value)
  }

  return (
    <>
      {AuthenticateUser('send-quick-sms') && (
        <QuickMessageDrawerInner
          handleClose={() => setQuickMessagePopup(false)}
          show={quickMessagePopup}

        //  valid={valid} setValid={setValid} virtualNumber={virtualNumber}
        />
      )}

      <div className='d-flex align-items-stretch flex-shrink-0'>
        {/* {header.left === 'page-title' && <DefaultTitle />} */}
        {!isNewNavigation && (
          <div className='aside-footer flex-column-auto pt-4 pb-7 px-3'>
            <div className='dropdown'>
              {(AuthenticateUser('send-quick-sms') && !isMobile) && (
                <button
                  className='btn btn-primary dropdown-toggle py-2'
                  type='button'
                  id='dropdownMenuButton'
                  data-bs-toggle='dropdown'
                  aria-expanded={isQuickActionOpen ? 'true' : 'false'}
                  onClick={() => setIsQuickActionOpen(!isQuickActionOpen)}
                >
                  Quick Action{' '}
                  {isQuickActionOpen ? (
                    <ChevronUp className='ms-5' />
                  ) : (
                    <ChevronDown className='ms-5' />
                  )}
                </button>
              )}

              <ul className='dropdown-menu' aria-labelledby='dropdownMenuButton' ref={ref}>
                {AuthenticateUser('send-quick-sms') && (
                  <li>
                    <Link
                      to='/contacts/subscriber'
                      className='dropdown-item'
                      onClick={() => setIsQuickActionOpen(false)}
                    >
                      Upload Contact
                    </Link>
                  </li>
                )}
                {AuthenticateUser('send-quick-sms') && (
                  <li>
                    <a
                      className='dropdown-item'
                      onClick={() => {
                        setQuickMessagePopup(true)
                        setIsQuickActionOpen(false)
                      }}
                    >
                      Send Quick Message
                    </a>
                  </li>
                )}

                {AuthenticateUser('send-quick-sms') && (
                  <li>
                    <Link
                      to='/new-message'
                      className='dropdown-item'
                      onClick={() => setIsQuickActionOpen(false)}
                    >
                      Send Bulk Message
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
        )}

        {!isNewNavigation && (
          <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
            {/* begin::Menu- wrapper */}
            <div
              className={clsx(
                'btn btn-icon btn-active-light-primary btn-custom btn-custom notification',
                toolbarButtonHeightClass
              )}
              data-kt-menu-trigger='hover'
              data-kt-menu-attach='parent'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='bottom'
            >
              <KTSVG
                path='/media/icons/duotune/finance/piggie.svg'
                className={toolbarButtonIconSizeClass}
              />
              {credit === 0 ? (
                <span className='walletBadge'></span>
              ) : null}
            </div>
            <Wallet remainingCredit={handleSetCredit} />
            {/* end::Menu wrapper */}
          </div>
        )}

        {isNewNavigation && isMobile && (
          <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
            {/* begin::Menu- wrapper */}
            <div
              className={clsx(
                'btn btn-icon btn-active-light-primary btn-custom btn-custom notification',
                toolbarButtonHeightClass
              )}
              data-kt-menu-trigger='hover'
              data-kt-menu-attach='parent'
              data-kt-menu-placement='bottom-start'
              data-kt-menu-flip='bottom'
            >
              <KTSVG
                path='/media/icons/duotune/finance/piggie.svg'
                className={toolbarButtonIconSizeClass}
              />
              {credit === 0 ? (
                <span className='walletBadge'></span>
              ) : null}
            </div>
            <div className='menu menu-sub menu-sub-dropdown' data-kt-menu='true'>
              <div className='p-3'>
                <WalletV2 remainingCredit={handleSetCredit} />
              </div>
            </div>
            {/* end::Menu wrapper */}
          </div>
        )}

        {isNewNavigation && !isMobile && (
          <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
            <WalletV2 remainingCredit={handleSetCredit} />
          </div>
        )}

        {isNewNavigation && (
          <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
            <div className='border border-2 border-gray-300 badge badge-light-primary rounded-pill'>
              <div className='d-flex px-2 py-1 fw-400 text-primary gap-2 justify-content-center'>
                <span className='status-bullet-dot'></span>
                <span>Chat</span>
              </div>
            </div>
          </div>
        )}

        {/* NOTIFICATIONS */}
        <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
          {/* begin::Menu- wrapper */}
          <div
            className={clsx(
              'btn btn-icon btn-active-light-primary btn-custom notification',
              toolbarButtonHeightClass
            )}
            data-kt-menu-trigger='hover'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <KTSVG
              path='/media/icons/duotune/general/gen007.svg'
              className={toolbarButtonIconSizeClass}
            />
            {+sys?.length + +port?.length > 0 && (
              <span className='notificationBadge'>{+sys?.length + +port?.length}</span>
            )}
          </div>
          <HeaderNotificationsMenu />
          {/* end::Menu wrapper */}
        </div>

        {/* Quick links */}
        {!isNewNavigation && (
          <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
            {/* begin::Menu wrapper */}
            <div
              className={clsx(
                'btn btn-icon btn-active-light-primary btn-custom',
                toolbarButtonHeightClass
              )}
              data-kt-menu-trigger='hover'
              data-kt-menu-attach='parent'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='bottom'
            >
              <KTSVG
                path='/media/icons/duotune/general/gen046.svg'
                className={toolbarButtonIconSizeClass}
              />
            </div>
            <QuickLinks />
            {/* end::Menu wrapper */}
          </div>
        )}

        {/* Quick links */}
        {isNewNavigation && (
          <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
            {/* begin::Menu wrapper */}
            <div
              className={clsx(
                'd-inline-flex align-items-center fw-semibold cursor-pointer gap-2 text-nowrap px-3 py-1 rounded-4',
              )}
              data-kt-menu-trigger='hover'
              data-kt-menu-attach='parent'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='bottom'
            >
              {!isMobile && (
                  <span className="text-nowrap text-gray-600">Help</span>
              )}
              <KTSVG
                path='/media/icons/duotune/general/gen046.svg'
                className={toolbarButtonIconSizeClass}
              />
            </div>
            <QuickLinks />
            {/* end::Menu wrapper */}
          </div>
        )}

        {/* Search */}
        {/* <div className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}>
          <Search />
        </div> */}

        {/* begin::User */}
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          {/* begin::Toggle */}
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
            data-kt-menu-trigger='hover'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            {userValues?.avatar == '' || userValues?.avatar == undefined || userValues?.avatar == 'undefined' ? (
              <span className='circle1'>{`${userValues?.firstName !== undefined && userValues?.firstName !== ''
                ? userValues?.firstName?.split('')?.[0]?.toUpperCase() ?? 'C'
                : createFirstLetter(userValues?.name)?.firstName ?? 'C'
                }${userValues?.lastName !== undefined && userValues?.lastName !== ''
                  ? userValues?.lastName?.split('')?.[0]?.toUpperCase() ?? 'C'
                  : createFirstLetter(userValues?.name).lastName ?? 'C'
                }`}</span>
            ) : (
              <img src={userValues?.avatar} alt='avatar' />
            )}
          </div>
          <HeaderUserMenu />
          {/* end::Toggle */}
        </div>
        {/* end::User */}

        {/* begin::Aside Toggler */}
        {config.header.left === 'menu' && (
          <div
            className='d-flex align-items-center d-none d-lg-none ms-2 me-n3'
            title='Show header menu'
          >
            <div
              className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
              id='kt_header_menu_mobile_toggle'
            >
              <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export { Topbar }
